import React, {Component} from "react"
import Responsive from "react-responsive"
import {translate} from "translate"

import {Button, Col, Row} from "elemental"
import {Link} from "react-router"
import CartButton from "../Cart/CartButton"
import shop from "../../shop/shop"
import app from "../../app.controller"
import SearchBar from "../Search/SearchBar"
import TopNavigation from "./TopNavigation"
import HeaderMobile from "./HeaderMobile"
import "./header.scss"

// import Navigation from "../Navigation/Navigation"
class Header extends Component {
	constructor() {
		super()
		this.state = {
			list        : shop.orderlist.default,
			categoryData: false
		}
		shop.events.loaded.add( this.handleLoad )
		shop.orderlist.default.events.change.add( this.handleOrderlist )
	}

	handleOrderlist = ( {list} ) => {
		if ( !this.mounted ) return
		this.setState( {
			list
		} )
	}

	handleLoad = () => {
		if ( !this.mounted ) return
		this.setState( {
			categoryData: shop.categories
		} )
	}

	componentDidMount() {
		this.mounted = true
	}

	componentWillUnmount() {
		this.mounted = false
		shop.orderlist.default.events.change.remove( this.handleOrderlist )
		shop.events.loaded.remove( this.handleLoad )
	}

	render() {
		let {list} = this.state
		// let categoryData = shop.categories
		{/*let categories   = categoryData.map((category) => <Link key={category.map_id}*/
		}
		{/*activeClassName="active"*/
		}
		{/*to={`/collection/${category.map_id}`}> {category.title}</Link>)*/
		}
		return (
			<header className="header">
				<Responsive minWidth={992}>
					<MenuTop />
					<MenuUtility list={list} />
				</Responsive>
				<Responsive maxWidth={991}>
					<HeaderMobile />
				</Responsive>
			</header>
		)
	}
}


export default Header

const MenuTop = () => {
	return (
		<div className="container-fluid top-bar ">
			<div className="container">
				<Row>
					<Col>
						<div className="pull-left">
						</div>
						<div className="pull-right ">
							{shop.session && <Link className="pull-left ml3 btn-secondary"
												   type="link"
												   to="/account"> <i className="icon icon-user" />{translate( "nav.account" )}</Link>
							}

							{shop.session && <Link className="pull-left ml3 btn-secondary"
												   type="link"
												   to="/logout">{translate( "nav.logout" )}</Link>}

							{!shop.session && <Link className="pull-left ml3 btn-secondary"
													type="link"
													to={`/login?referrer=${document.location.pathname}`}>Login</Link>}
							{!shop.session && <Link className="pull-left ml3 btn-secondary"
													type="link"
													to="/customer_registration">{translate( "shop.register" )}</Link>}
						</div>
						<div className="  text-right">
							<div className="pull-right">
								<Button onClick={() => {
									app.language.changed.dispatch( "en-US" )
									window.location.reload()
								}
								}
										className={`mr2 lang-button ${app._currentLanguage === "en" && "active"}`}>
									<span className="visible-sm-inline visible-md-inline visible-lg-inline">EN</span>
								</Button>
								<Button
									onClick={() => {
										app.language.changed.dispatch( "fr" )
										window.location.reload()
									}
									}
									className={`mr2 lang-button ${app._currentLanguage === "fr" && "active"}`}>
									<span className="visible-sm-inline visible-md-inline visible-lg-inline">FR</span>
								</Button>
								<Button onClick={() => {
									app.language.changed.dispatch( "de-DE" )
									window.location.reload()
								}

								}
										className={`lang-button ${app._currentLanguage === "de" && "active"}`}>
									<span className="visible-sm-inline visible-md-inline visible-lg-inline">DE</span>
								</Button>
							</div>
						</div>
					</Col>
				</Row>
			</div>
		</div>
	)
}

const MenuUtility = ( {list} ) => {
	return (
		<div className="container-fluid utility-bar">
			<div className="container">
				<Row>
					<Col sm="2/6"
						 md="5/12"
						 style={{marginTop: "30px"}}>
						<div style={{maxWidth: "380px"}}>
							<SearchBar />
						</div>
					</Col>

					<Col sm="2/6"
						 md="2/12"
						 className="tc">
						<Link to="/home">
							<div className="logo--shop block">
								<img
									src="/logo.png"
									alt="MAGS" />
							</div>
						</Link>
					</Col>
					{shop.session && <Col sm="2/6"
										  md="5/12"
										  style={{marginTop: "30px"}}>
						<div className="pull-right">
							<Link className="u-pos-relative"
								  to="/orderlist/Merkliste"><Button type="link"><i className="icon-paste" /><span className="visible-md-inline visible-lg-inline">{translate(
								"nav.orderlist" )}</span>
								<span className="badge badge-small">{list.size}</span></Button></Link>
							<CartButton />
						</div>
					</Col>}
				</Row>
				<TopNavigation />
			</div>
		</div>
	)
}



// WEBPACK FOOTER //
// ./src/components/Header/Header.js